export interface ISplitAccountValues {
    assetsClosingValue: number;
    assetsOpeningValue: number;
    liabilitiesClosingValue: number;
    liabilitiesOpeningValue: number;
}
